import {getIsCurrentUserEmail} from '@utils/emailMatching';

interface RecipientWithEmail {
    email?: string | null;
}

interface OwnerUser {
    email?: string | null;
    firstName?: string;
    lastName?: string;
    language?: string;
    company?: string;
    title?: string;
}

interface OwnerRecipientData {
    email: string;
    first_name: string;
    last_name: string;
    order: number;
    language?: string;
    organisation?: string;
    title?: string;
}

/** Returns the owner recipient payload, or null when the owner is already a recipient under any of their emails. */
export function getOwnerRecipientToCreate(
    existingRecipients: RecipientWithEmail[],
    currentUser: OwnerUser | null | undefined,
    currentUserEmails: string[]
): OwnerRecipientData | null {
    if (!currentUser?.email) {
        return null;
    }
    const isOwnerAlreadyRecipient = existingRecipients.some(
        (recipient) => getIsCurrentUserEmail(recipient?.email, currentUserEmails)
    );
    if (isOwnerAlreadyRecipient) {
        return null;
    }
    const data: OwnerRecipientData = {
        email: currentUser.email,
        first_name: currentUser.firstName || '',
        last_name: currentUser.lastName || '',
        order: existingRecipients.length
    };
    if (currentUser.language) data.language = currentUser.language;
    if (currentUser.company) data.organisation = currentUser.company;
    if (currentUser.title) data.title = currentUser.title;
    return data;
}
